import { useMemo } from 'react';
import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { useCnpjAlphanumeric } from '@ibk/shared-ui';
import { isValidCpf } from '@ibk/shared-utils';
export function usePersonType() {
    const accountInfo = getSelectedAccountInfo();
    const { isValidCnpj } = useCnpjAlphanumeric();
    const result = useMemo(() => {
        if (!accountInfo?.documentNumber) {
            return {
                isPersonFisica: false,
                isPersonJuridica: false,
                documentNumber: null,
                documentType: null,
                isLoading: true,
            };
        }
        const { documentNumber } = accountInfo;
        const isCpf = isValidCpf(documentNumber);
        const isCnpj = isValidCnpj(documentNumber);
        let documentType = null;
        if (isCpf) {
            documentType = 'CPF';
        }
        else if (isCnpj) {
            documentType = 'CNPJ';
        }
        return {
            isPersonFisica: isCpf,
            isPersonJuridica: isCnpj,
            documentNumber,
            documentType,
            isLoading: false,
        };
    }, [accountInfo, isValidCnpj]);
    return result;
}
